import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    hostedLabel: 'I am hosted',
    selfHostedLabel: 'I have a document in my name',
    subTitleAddProofOfAddress: 'Add a proof of address',
  },
  fr: {
    hostedLabel: 'Je suis hébergé·e',
    selfHostedLabel: 'J’ai un document à mon nom',
    subTitleAddProofOfAddress: 'Ajouter un justificatif de domicile',
  },
} as const);
